import React from 'react';
import { useFormField } from '../../useFormField';
import type { AddressViewModel } from '@generated';
import { AddressField } from '../base-fields/AddressField';

interface AddressFormFieldProps {
	freeForm?: boolean;
	showAddressNotes?: boolean;
	isReadOnly?: boolean;
	name: string;
}

export function AddressFormField(props: AddressFormFieldProps) {
	const fieldProps = useFormField<AddressViewModel | null>(props);
	return <AddressField {...fieldProps} />;
}
